import React from "react";
import { useInteractiveProductsSettings } from "../../../context/interactive-product-context.jsx";
import { InteractiveButton } from "../../InteractiveButton.jsx";
import { optionalTranslation } from "../../../../translations/translation-utils.js";

export const ZoomButton = ({ onClick = undefined }) => {
	const { zoomIconPath, translations } = useInteractiveProductsSettings();

	const zoomTitle = optionalTranslation(
		translations["button.zoom.expand.title"]
	);

	return (
		<InteractiveButton
			buttonImageSrc={zoomIconPath}
			onClick={onClick}
			imgIconImageAlt={optionalTranslation(
				translations["button.zoom.expand.icon.alt"]
			)}
			title={zoomTitle}
		/>
	);
};
